'use client'

import { useCallback, ReactNode, useRef, useEffect } from 'react'
import classNames from 'classnames'

import type { Props } from './product-card-gallery'
import { useTrackingOnScreen } from '@dustin-web/microsite-components/src/on-screen'
import { pushViewItemList } from './utils'
import { getRefVar, lastIndexVar } from '@dustin-web/microsite-components/src/hooks/vars'

type ContainerProps = {
  children: ReactNode
  sizeClasses?: Props['sizeClasses']
  isExtraItem?: Props['isExtraItem']
  inFilterList?: Props['inFilterList']
  digitalIndex: Props['digitalIndex']
  digitalDataOrigin: Props['digitalDataOrigin']
  product: Props['product']
  customClassName?: string
  isCampaignProduct?: boolean
}

export default function Container({
  children,
  sizeClasses = '',
  isExtraItem = false,
  inFilterList = false,
  digitalIndex,
  digitalDataOrigin,
  product,
  customClassName,
  isCampaignProduct,
}: ContainerProps) {
  const push = useCallback(() => {
    pushViewItemList(digitalIndex, product, digitalDataOrigin, isCampaignProduct)
  }, [digitalIndex, product, digitalDataOrigin, isCampaignProduct])
  const ref = useTrackingOnScreen(push)

  const defaultClasses = classNames(sizeClasses, 'u-mb-8 u-mb-sm-16 u-color-black ', {
    'c-filter__extra-gallery-box': isExtraItem,
    'col-12 col-sm-6 col-md-4': inFilterList && !sizeClasses.length,
    'col-12 col-sm-6 col-md-4 col-lg-3': !inFilterList && !sizeClasses.length,
  })

  const indexRef = useRef<HTMLDivElement | null>(null)
  const storedIndex = lastIndexVar()

  useEffect(() => {
    if (digitalIndex && storedIndex !== null && storedIndex === digitalIndex) {
      if (indexRef.current) {
        getRefVar(indexRef)
      }
    }
  }, [storedIndex])

  return (
    <article ref={ref} className={customClassName || defaultClasses}>
      <div ref={indexRef}></div>
      {children}
    </article>
  )
}
